/**
 * Runtime environment helper.
 * Reads from window._env_ (Docker runtime injection) with fallback to
 * process.env (local development via CRA .env files).
 *
 * @param {string} key - Environment variable name (e.g., 'REACT_APP_SERVER_URL')
 * @returns {string|undefined} The environment variable value
 */
export const getEnv = (key) => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
};
